exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.excel-upload-input[data-v-32a217b2] {\n  display: none;\n  z-index: -9999;\n}\n", ""]);

// exports
